<template>
  <div v-if="isShow" class="loading" id="loading">
    <div class="loading-container">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "base-loading",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  updated() {
    if (this.isShow) document.body.classList.add("overflow-hidden");
    else document.body.classList.remove("overflow-hidden");
  },
};
</script>
